import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Project
const ProjectList = () => import('@/views/project/ProjectList')
const ProjectMod = () => import('@/views/project/ProjectMod')
const ProjectBOM = () => import('@/views/project/BomEdit')

// Repository
const CompAdd = () => import('@/views/component/CompAdd')
const CompEdit = () => import('@/views/component/CompEdit')
const CompSearch = () => import('@/views/component/CompSearch')
const CompHistory = () => import('@/views/component/History')

// Setting
const Setting = () => import('@/views/setting/Setting')


// Customer
const OrderList = () => import('@/views/customer/OrderList')
const OrderEdit = () => import('@/views/customer/OrderEdit')
const Binaries = () =>import('@/views/customer/Binaries')
const CustomProducts = () =>import('@/views/customer/Products')
// User
const UserPassword = () => import('@/views/user/Password')
const UserList = () => import('@/views/user/Users')
const UserRegister = () => import('@/views/user/Register')

// Devices
const Connections = () => import('@/views/device/Connections')
const Products = () => import('@/views/device/Products')
const Import = () => import('@/views/device/Import')
const ProdEdit = () => import('@/views/device/ProductEdit')
const DeviceFeatures = () => import('@/views/device/License')
const LicEdit = ()=> import('@/views/device/LicEdit')
const Deliver = ()=> import('@/views/device/Deliver')
const DelEdit = ()=> import('@/views/device/DelEdit')
const Guarantee = ()=> import('@/views/device/Guarantee')
const GuaEdit = ()=> import('@/views/device/GuaEdit')
const Customer = ()=> import('@/views/device/Customer')
const CusEdit = ()=> import('@/views/device/CusEdit')
const Contract = ()=> import('@/views/device/Contract')
const CtrEdit = ()=> import('@/views/device/CtrEdit')


// Login, error
const Login = () => import('@/views/pages/Login')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Register = () => import('@/views/pages/Register')
const ForgetPw = () => import('@/views/pages/ForgetPw')

const About = () => import('@/views/pages/About')
const Actions = () => import('@/views/pages/Actions')


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Trang chủ',
      component: TheContainer,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'dashboard',
          meta: { requiresAuth: true },
          component: Dashboard
        },
        {
          path: 'component',
          redirect: '/component/search',
          meta: { requiresAuth: true },
          name: 'Linh kiện',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'search',
              name: 'Tìm kiếm',
              meta: { requiresAuth: true },
              component: CompSearch
            },
            {
              path: 'add',
              name: 'Nhập',
              meta: { requiresAuth: true },
              component: CompAdd
            },
            {
              path: 'mod',
              name: 'Biên tập',
              meta: { requiresAuth: true },
              component: CompEdit
            },
            {
              path: 'history',
              name: 'Lich sử',
              meta: { requiresAuth: true },
              component: CompHistory
            }
          ]
        },
        {
          path: 'project',
          redirect: '/project/list',
          name: 'Dự án',
          meta: { requiresAuth: true },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Danh sách',
              meta: { requiresAuth: true },
              component: ProjectList
            },
            {
              path: 'mod',
              name: 'Chỉnh sửa',
              meta: { requiresAuth: true },
              component: ProjectMod
            },
            {
              path: 'bom',
              name: 'Chỉnh sửa BOM',
              meta: { requiresAuth: true },
              component: ProjectBOM
            }
          ]
        },
        {
          path: 'setting',
          name: 'Cài đặt',
          meta: { requiresAuth: true },
          component: Setting
        },
        {
          path: 'device',
          redirect: '/device/status',
          name: 'Quản lý',
          meta: { requiresAuth: true },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'status',
              name: 'Kết nối',
              meta: { requiresAuth: true },
              component: Connections
            },
            {
              path: 'products',
              name: 'Sản phẩm',
              meta: { requiresAuth: true },
              component: Products
            },
            {
              path: 'prodedit',
              name: 'Thông tin sản phẩm',
              meta: { requiresAuth: true },
              component: ProdEdit
            },
            {
              path: 'import',
              name: 'Nhập từ tệp',
              meta: { requiresAuth: true },
              component: Import
            },
            {
              path: 'license',
              name: 'Giấy phép',
              meta: { requiresAuth: true },
              component: DeviceFeatures
            },
            {
              path: 'licedit',
              name: 'Tạo giấy phép',
              meta: { requiresAuth: true },
              component: LicEdit
            },
            {
              path: 'deliver',
              name: 'Giao hàng',
              meta: { requiresAuth: true },
              component: Deliver
            },
            {
              path: 'deledit',
              name: 'Thông tin giao hàng',
              meta: { requiresAuth: true },
              component: DelEdit
            },
            {
              path: 'guarantee',
              name: 'Bảo hành',
              meta: { requiresAuth: true },
              component: Guarantee
            },
            {
              path: 'guaedit',
              name: 'Thông tin bảo hành',
              meta: { requiresAuth: true },
              component: GuaEdit
            },
            {
              path: 'customer',
              name: 'Khách hàng',
              meta: { requiresAuth: true },
              component: Customer
            },
            {
              path: 'cusedit',
              name: 'Thông tin khách hàng',
              meta: { requiresAuth: true },
              component: CusEdit
            },
            {
              path: 'contract',
              name: 'Quản lý hợp đồng',
              meta: { requiresAuth: true },
              component: Contract
            },
            {
              path: 'ctredit',
              name: 'Thông tin hợp đồng',
              meta: { requiresAuth: true },
              component: CtrEdit
            }

          ]
        },
        {
          path: 'customer',
          redirect: '/customer/list',
          name: 'Sản xuất',
          meta: { requiresAuth: true },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'products',
              name: 'Theo dõi sản phẩm',
              meta: { requiresAuth: true },
              component: CustomProducts
            },
            {
              path: 'update',
              name: 'Cập nhật tệp',
              meta: { requiresAuth: true },
              component: Binaries
            },
            {
              path: 'create',
              name: 'Tạo đơn hàng',
              meta: { requiresAuth: true },
              component: OrderEdit
            },
            {
              path: 'new',
              name: 'Tạo mới',
              meta: { requiresAuth: true },
              component: OrderList
            },
            {
              path: 'confirm',
              name: 'Đã xác nhận',
              meta: { requiresAuth: true },
              component: OrderList
            },
            {
              path: 'running',
              name: 'Đang thực hiện',
              meta: { requiresAuth: true },
              component: OrderList
            },
            {
              path: 'complete',
              name: 'Hoàn thành',
              meta: { requiresAuth: true },
              component: OrderList
            },
            {
              path: 'overdue',
              name: 'Quá hạn',
              meta: { requiresAuth: true },
              component: OrderList
            },
            {
              path: 'cancel',
              name: 'Hủy bỏ',
              meta: { requiresAuth: true },
              component: OrderList
            },
            {
              path: 'list',
              name: 'Toàn bộ',
              meta: { requiresAuth: true },
              component: OrderList
            },
          ]
        },
        {
          path: 'user',
          redirect: '/user/password',
          name: 'Tài khoản',
          meta: { requiresAuth: true },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'password',
              name: 'Mật khẩu',
              meta: { requiresAuth: true },
              component: UserPassword
            },
            {
              path: 'list',
              name: 'Danh sách tài khoản',
              meta: { requiresAuth: true },
              component: UserList
            },
            {
              path: 'register',
              name: 'Đăng ký',
              meta: { requiresAuth: true },
              component: UserRegister
            }
          ]
        },
        {
          path: 'about',
          name: 'Giới thiệu',
          meta: { requiresAuth: true },
          component: About
        },
        {
          path: 'actions',
          name: 'Lịch sử thao tác',
          meta: { requiresAuth: true },
          component: Actions
        }
      ]
    },
    {
      path: '/',
      redirect: '/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'forget',
          name: 'Forget',
          component: ForgetPw
        },
      ]
    }
  ]
})

export default router;
